module.exports = __webpack_public_path__ + "assets/img/siding-4.dd52ac9a.jpg";